import { OutgoingMailPostingOptionDTO } from "../../models/outgoing-mail-posting-option/outgoing-mail-posting-option-dto";
import { BaseApiService } from "../base";
import { OutgoingMailPostingOptionSTO } from "../../models/outgoing-mail-posting-option/outgoing-mail-posting-option-sto";

export class OutgoingMailPostingOptionApiService extends BaseApiService<
  OutgoingMailPostingOptionDTO,
  OutgoingMailPostingOptionSTO
> {
  constructor() {
    super({
      servicePath: "/OutgoingMailPostingOption",
      loadItemsPath: "/GetOutgoingMailPostingOptions",
    });
  }
}
